import React, { useCallback, useRef } from 'react'
import { useSpring, animated as a, interpolate } from 'react-spring'
function Button({ type,onNextClick }) {
  const bgRef = useRef()
  const [{ xy }, set] = useSpring(() => ({ xy: [-40,-35] }))
  const onMove = useCallback(({ clientX: x, clientY: y }) => {
    if(screen.width>500)
    set({ xy: [bgRef.current.getBoundingClientRect().left - x, bgRef.current.getBoundingClientRect().top - y] })
    // console.log(xy.getValue())
  }, [])
  const onOut = () => {        
    bgRef.current.classList.remove("hovered");
    set({ xy: [-40,-35] })
  }
  const onIn = ()=>{
    bgRef.current.classList.add("hovered");
  }
  const interpBg = xy.interpolate((x, y) => (bgRef.current ? `translate3d(${-x - 90}%, ${-y - 80}%, 0)` : `translate3d(0,0,0)`))
  return (
    <div className="btn" onMouseMove={onMove} onMouseLeave={onOut} onMouseEnter={onIn} ref={bgRef}>
      <a.svg className="btn_bg" viewBox="0 0 46.5 45.5" style={{ transform: interpBg }} onClick={()=>onNextClick(type)}>
        <path d="M44.533,26.132 L39.391,37.308 L28.893,43.949 L16.374,43.946 L5.806,37.301 L0.546,26.122 L2.264,13.960 L10.414,4.676 L22.408,1.216 L34.439,4.681 L42.687,13.969 L44.533,26.132 Z"></path>
        {type === 'down' && (
          <path style={{fillRule: "evenodd",transform:"translate(39%, 46%)"}} fill="white" d="M1.420,-0.008 L5.000,3.336 L8.580,-0.008 L10.012,1.330 L6.432,4.674 L5.000,6.012 L3.568,4.674 L-0.012,1.330 L1.420,-0.008 Z"></path>
        )}
        {type === 'up' && (
          <path style={{fillRule: "evenodd",transform:"translate(39%, 46%)"}} fill="white " d="M9.036,6.914 L5.500,3.379 L1.964,6.914 L0.550,5.500 L4.086,1.964 L5.500,0.550 L6.914,1.964 L10.450,5.500 L9.036,6.914 Z"></path>
        )}
      </a.svg>
      {/* <svg className="btn_arrow" viewBox="0 0 10 6" width="10" height="6" style={{ transform: interpBg }}>
        
      </svg> */}
    </div>
  )
}

export default Button
